import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { SamwinLineStatusRemoteDto } from 'src/generated/signalR/samwin-line-status-remote-dto';
import { EmailBehaviourState } from '../email/email-behaviour/email-behaviour.state';
import { MessageInfo } from '../samwin-mail-list/message-info';
import { SamwinMessageListStateSelectors } from '../samwin-mail-list/samwin-message-list.selectors';
import { SamwinMessageListState } from '../samwin-mail-list/samwin-message-list.state';
import { MailingFolderEnum } from '../samwin-skills/mailing-folders-enum';
import { SamwinMessageLinesState } from './samwin-message-lines.state';

export class SamwinMessageLinesStateSelectors {
   // Put the selectors which use other states here

   @Selector([SamwinMessageLinesState.getAssignedLines, SamwinMessageListStateSelectors.getAllLoadedMessages])
   public static getCurrentAssignedMessages(assignedLines: SamwinLineStatusRemoteDto[], waitlist: MessageInfo[]): MessageInfo[] {
      return assignedLines.map((line) => waitlist.find((message) => message.callId === line?.callId));
   }

   @Selector([SamwinMessageLinesStateSelectors.getCurrentAssignedMessages])
   public static getCurrentAssignedMessage(assignedMessages: MessageInfo[]): MessageInfo {
      return _(assignedMessages).head();
   }

   @Selector([
      SamwinMessageLinesState.getConnectedLines,
      EmailBehaviourState.getOpenEmailWindows,
      SamwinMessageListStateSelectors.getMessageIdByCallId,
      SamwinMessageListState.getCurrentContentIds,
      SamwinMessageListStateSelectors.getMessageFolderById,
   ])
   public static getMessagesToOpen(
      connectedLines: SamwinLineStatusRemoteDto[],
      openMails: string[],
      getMessageId: (callId: number) => string,
      currentMessageIds: string[],
      getFolder: (messageId: string) => string
   ) {
      const connectedLineIds = connectedLines.map((cl) => getMessageId(cl.callId)).filter((messageId) => getFolder(messageId) === MailingFolderEnum.INBOX.name);
      const openedInboxMessages = _.concat(openMails, currentMessageIds);
      return _.differenceBy(connectedLineIds, openedInboxMessages);
   }

   @Selector([
      SamwinMessageLinesState.getConnectedLines,
      EmailBehaviourState.getOpenEmailWindows,
      SamwinMessageListStateSelectors.getMessageIdByCallId,
      SamwinMessageListStateSelectors.getMessageFolderById,
   ])
   public static getMessagesToClose(
      connectedLines: SamwinLineStatusRemoteDto[],
      openMails: string[],
      getMessageId: (callId: number) => string,
      getFolder: (messageId: string) => string
   ) {
      const connectedLineIds = connectedLines.map((cl) => getMessageId(cl.callId));

      const openedInboxMessages = openMails.filter(
         (messageId) => isNaN(+messageId) && (_.isNil(getFolder(messageId)) || getFolder(messageId) === MailingFolderEnum.INBOX.name)
      );
      return _.differenceBy(openedInboxMessages, connectedLineIds);
   }
}
